import { render, staticRenderFns } from "./GovernanceEventForm.vue?vue&type=template&id=52815fd2&"
import script from "./GovernanceEventForm.vue?vue&type=script&lang=js&"
export * from "./GovernanceEventForm.vue?vue&type=script&lang=js&"
import style0 from "./GovernanceEventForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports